import axios from "axios";

const ENDPOINT_URL = "/payment/api/v1/subscription";

const get = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(ENDPOINT_URL)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response.data);
      });
  });
};

const subscriptionPlan = {
  get
};

export default subscriptionPlan;
